module.exports = __webpack_public_path__ + "media/images/flags/32/Estonia-1d9d901eb09c950dc8e552caae8f8fa5.png";